module.exports = __webpack_public_path__ + "static/media/about.c624d7c3.png";